import { render } from "./Penalty_Batches.vue?vue&type=template&id=5b8d605a&scoped=true"
import script from "./Penalty_Batches.vue?vue&type=script&lang=js"
export * from "./Penalty_Batches.vue?vue&type=script&lang=js"

import "./Penalty_Batches.vue?vue&type=style&index=0&id=5b8d605a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8d605a"]])

export default __exports__